// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.react-calendar {
  width: 404px !important;
  border-radius: 6px !important;
  font-family: "Nunito Sans", sans-serif !important;
  padding: 24px !important;
  overflow: hidden;
  position: absolute !important;
  z-index: 77;
}

.app_page {
  transform: translateY(10px);
  right: 12px;
}

.stat_page {
  transform: translateY(50px);
  right: -140px;
}

.react-calendar__tile {
  margin: 0 !important;
  border: 1px solid #dce0e5 !important;
  background-color: #ffffff !important;
  max-width: 40px !important;
  height: 40px !important;
  border-radius: 6px !important;
  transition: background-color 0.3s;
}
.react-calendar__tile:hover {
  background-color: #dce8f4 !important;
}

.react-calendar__navigation {
  margin-bottom: 1px !important;
}

.react-calendar__month-view__weekdays__weekday {
  max-width: 40px !important;
  margin: 0 !important;
  padding: 0.5rem 0 !important;
}

.react-calendar__month-view__weekdays {
  gap: 12px !important;
}

.react-calendar__month-view__days {
  gap: 12px !important;
}

.react-calendar__tile--active {
  background-color: #1367b5 !important;
  color: #ffffff !important;
  border-radius: 50%;
}

.react-calendar__navigation__label__labelText {
  font-weight: 500 !important;
  font-size: 20px !important;
  line-height: 28px !important;
}

.react-calendar__month-view__weekdays__weekday abbr[title] {
  text-decoration: none !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
}

.react-calendar__navigation__label {
  text-transform: capitalize !important;
  transition: all 0.3s linear;
  background-color: #ffffff !important;
}
.react-calendar__navigation__label:hover {
  border-radius: 6px;
  background-color: #dce8f4 !important;
}

.react-calendar__navigation__arrow {
  transition: all 0.3s linear;
}
.react-calendar__navigation__arrow:hover {
  border-radius: 6px;
  background-color: #dce8f4 !important;
}

.appointmen_placed {
  transform: translateY(10px);
  right: 12px;
}

.stats_placed {
  transform: translateY(50px);
  right: -140px;
}

.shedule_placed {
  transform: translateY(10px);
  left: 400px;
  top: 64px;
}

.react-calendar__year-view__months,
.react-calendar__decade-view__years {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 10px; /* Відступи */
  padding: 10px;
}

.react-calendar__year-view__months button,
.react-calendar__decade-view__years button {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-transform: capitalize !important;
}

.react-calendar__month-view__days__day--neighboringMonth {
  border: none !important;
  background: none !important; /* Якщо потрібно також прибрати фон */
}`, "",{"version":3,"sources":["webpack://./src/components/Calendar/Calendar.scss","webpack://./styles/_typography.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACI,uBAAA;EACA,6BAAA;EACA,iDAAA;EACA,wBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;AAAJ;;AAEA;EACI,2BAAA;EACA,WAAA;AACJ;;AAEA;EACI,2BAAA;EACA,aAAA;AACJ;;AAEA;EACI,oBAAA;EACA,oCAAA;EACA,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,6BAAA;EACA,iCAAA;AACJ;AAAI;EACI,oCAAA;AAER;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,0BAAA;EACA,oBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AACA;EACI,oBAAA;AAEJ;;AACA;EACI,oCAAA;EACA,yBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,2BAAA;EACA,0BAAA;EACA,4BAAA;AAEJ;;AACA;EACI,gCAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AAEJ;;AACA;EACI,qCAAA;EACA,2BAAA;EACA,oCAAA;AAEJ;AADI;EACI,kBAAA;EACA,oCAAA;AAGR;;AAAA;EACI,2BAAA;AAGJ;AAFI;EACI,kBAAA;EACA,oCAAA;AAIR;;AAAA;EACI,2BAAA;EACA,WAAA;AAGJ;;AAAA;EACI,2BAAA;EACA,aAAA;AAGJ;;AAAA;EACI,2BAAA;EACA,WAAA;EACA,SAAA;AAGJ;;AAAA;;EAEI,wBAAA;EACA,gDAAA;EACA,SAAA,EAAA,aAAA;EACA,aAAA;AAGJ;;AAAA;;EAEI,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EC9BA,gBAAA;EACA,eAAA;EACA,iBAAA;ED8BA,qCAAA;AAKJ;;AAFA;EACI,uBAAA;EACA,2BAAA,EAAA,qCAAA;AAKJ","sourcesContent":["@import \"../../../styles/colors\";\r\n@import \"../../../styles/_typography.scss\";\r\n.react-calendar {\r\n    width: 404px !important;\r\n    border-radius: 6px !important;\r\n    font-family: \"Nunito Sans\", sans-serif !important;\r\n    padding: 24px !important;\r\n    overflow: hidden;\r\n    position: absolute !important;\r\n    z-index: 77;\r\n}\r\n.app_page {\r\n    transform: translateY(10px);\r\n    right: 12px;\r\n}\r\n\r\n.stat_page {\r\n    transform: translateY(50px);\r\n    right: -140px;\r\n}\r\n\r\n.react-calendar__tile {\r\n    margin: 0 !important;\r\n    border: 1px solid $divider !important;\r\n    background-color: $color-white !important;\r\n    max-width: 40px !important;\r\n    height: 40px !important;\r\n    border-radius: 6px !important;\r\n    transition: background-color 0.3s;\r\n    &:hover {\r\n        background-color: $buttons_outlined_pressed !important;\r\n    }\r\n}\r\n\r\n.react-calendar__navigation {\r\n    margin-bottom: 1px !important;\r\n}\r\n\r\n.react-calendar__month-view__weekdays__weekday {\r\n    max-width: 40px !important;\r\n    margin: 0 !important;\r\n    padding: 0.5rem 0 !important;\r\n}\r\n\r\n.react-calendar__month-view__weekdays {\r\n    gap: 12px !important;\r\n}\r\n.react-calendar__month-view__days {\r\n    gap: 12px !important;\r\n}\r\n\r\n.react-calendar__tile--active {\r\n    background-color: $buttons_stroke_solid !important;\r\n    color: $color-white !important;\r\n    border-radius: 50%;\r\n}\r\n\r\n.react-calendar__navigation__label__labelText {\r\n    font-weight: 500 !important;\r\n    font-size: 20px !important;\r\n    line-height: 28px !important;\r\n}\r\n\r\n.react-calendar__month-view__weekdays__weekday abbr[title] {\r\n    text-decoration: none !important;\r\n    font-weight: 400 !important;\r\n    font-size: 14px !important;\r\n    line-height: 20px !important;\r\n}\r\n\r\n.react-calendar__navigation__label {\r\n    text-transform: capitalize !important;\r\n    transition: all 0.3s linear;\r\n    background-color: $color-white !important;\r\n    &:hover {\r\n        border-radius: 6px;\r\n        background-color: $buttons_outlined_pressed !important;\r\n    }\r\n}\r\n.react-calendar__navigation__arrow {\r\n    transition: all 0.3s linear;\r\n    &:hover {\r\n        border-radius: 6px;\r\n        background-color: $buttons_outlined_pressed !important;\r\n    }\r\n}\r\n\r\n.appointmen_placed {\r\n    transform: translateY(10px);\r\n    right: 12px;\r\n}\r\n\r\n.stats_placed {\r\n    transform: translateY(50px);\r\n    right: -140px;\r\n}\r\n\r\n.shedule_placed {\r\n    transform: translateY(10px);\r\n    left: 400px;\r\n    top: 64px;\r\n}\r\n\r\n.react-calendar__year-view__months,\r\n.react-calendar__decade-view__years {\r\n    display: grid !important;\r\n    grid-template-columns: repeat(3, 1fr) !important;\r\n    gap: 10px; /* Відступи */\r\n    padding: 10px;\r\n}\r\n\r\n.react-calendar__year-view__months button,\r\n.react-calendar__decade-view__years button {\r\n    width: 100px !important;\r\n    min-width: 100px !important;\r\n    max-width: 100px !important;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    @include typography($body2);\r\n    text-transform: capitalize !important;\r\n}\r\n\r\n.react-calendar__month-view__days__day--neighboringMonth {\r\n    border: none !important;\r\n    background: none !important; /* Якщо потрібно також прибрати фон */\r\n}\r\n","@import \"./colors\";\r\n\r\n$heading1: (\r\n    font-weight: 600,\r\n    font-size: 32px,\r\n    line-height: 40px,\r\n);\r\n\r\n$heading2: (\r\n    font-weight: 500,\r\n    font-size: 24px,\r\n    line-height: 36px,\r\n);\r\n\r\n$heading3: (\r\n    font-weight: 400,\r\n    font-size: 20px,\r\n    line-height: 28px,\r\n);\r\n\r\n$heading4: (\r\n    font-weight: 500,\r\n    font-size: 32px,\r\n    line-height: 40px,\r\n    color: $black-dark-active,\r\n);\r\n\r\n$body1: (\r\n    font-weight: 600,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body2: (\r\n    font-weight: 500,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body3: (\r\n    font-weight: 400,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body-small1: (\r\n    font-weight: 600,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$body-small2: (\r\n    font-weight: 500,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$body-small3: (\r\n    font-weight: 400,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$caption1: (\r\n    font-weight: 500,\r\n    font-size: 12px,\r\n    line-height: 14px,\r\n);\r\n\r\n$caption2: (\r\n    font-weight: 600,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$link1: (\r\n    font-weight: 400,\r\n    font-size: 12px,\r\n    line-height: 14px,\r\n);\r\n\r\n$headline3: (\r\n    font-weight: 500,\r\n    font-size: 20px,\r\n    line-height: 28px,\r\n);\r\n\r\n@mixin typography($style) {\r\n    font-weight: map-get($style, font-weight);\r\n    font-size: map-get($style, font-size);\r\n    line-height: map-get($style, line-height);\r\n    @if map-has-key($style, color) {\r\n        color: map-get($style, color);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
